interface RadioProps {
  checked?: boolean;
  disabled?: boolean;
  id: number | string;
  label: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  testId?: string | null;
  value: number | string | boolean;
}

const Radio = ({ checked, disabled, id, label, onChange, testId = null, value }: RadioProps) => (
  <div className="align-items-center d-flex form-check mb-3">
    <input
      className="form-check-input"
      checked={checked}
      data-testid={testId}
      disabled={disabled}
      id={String(id)}
      onChange={onChange}
      type="radio"
      value={String(value)}
    />
    <label className="form-check-label ps-2 text-0_875" htmlFor={String(id)}>
      {label}
    </label>
  </div>
);

export default Radio;
